import React, { lazy } from "react"
import { Route, Routes, Outlet } from "react-router-dom"
import { ROUTES } from "@constants"

import NotFoundPage from "@pages/not-found.page"
import SecureLayout from "./layouts/SecureLayout"

const RegistrationPage = lazy(
  () => import("@pages/Registration/registration.page")
)
const PaymentPage = lazy(() => import("@pages/payment/payment.page"))
const OthersBankTransferPage = lazy(
  () => import("@pages/payment/others-bank-transfer.page")
)
const PaymentBarCodePage = lazy(
  () => import("@pages/payment/payment-bar-code.page")
)
const PayPage = lazy(() => import("@pages/payment/pay.page"))
const Login = lazy(() => import("@pages/login/login.page"))
const Home = lazy(() => import("@pages/home/home.page"))
const Transaction = lazy(() => import("@pages/transaction/transaction.page"))
const Info = lazy(() => import("@pages/info/info.page"))

function AppRouter() {
  return (
    <Routes>
      <Route path={ROUTES.LOGIN()} element={<Login />} />
      <Route path={ROUTES.REGISTER()} element={<RegistrationPage />} />
      <Route
        path="/s"
        element={
          <SecureLayout>
            <Outlet />
          </SecureLayout>
        }
      >
        <Route path={ROUTES.HOME()} element={<Home />} />
        <Route path={ROUTES.TRANSACTION()} element={<Transaction />} />
        <Route path={ROUTES.INFORMATION()} element={<Info />} />
        <Route path={ROUTES.PAYMENT()} element={<PaymentPage />} />
        <Route
          path={ROUTES.PAYMENT_BAR_CODE()}
          element={<PaymentBarCodePage />}
        />
        <Route path={ROUTES.PAY()} element={<PayPage />} />
        <Route
          path={ROUTES.OTHERS_BANK_TRANSFER()}
          element={<OthersBankTransferPage />}
        />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRouter
